/**
 *
 * @returns {void}
 */
export default class SearchForm {
  /**
   * Constructor
   *
   * @returns {void}
   */
  constructor() {
    const scope = document.body;

    this.boundSubmitForm = (e) => this.submitForm(e);

    this.boundResetInput = () => this.resetInput();
    this.boundSetFocusedClassInput = () => this.setFocusedClassInput();

    this.boundToggleSearchMethods = () => this.toggleSearchMethods();
    this.boundCloseSearchMethods = (e) => this.closeSearchMethods(e);
    this.boundSetSearchMethod = (e) => this.setSearchMethod(e);

    this.form = scope.querySelector("#search-form");

    if (this.form) {
      this.input = this.form.querySelector("#search-input");
      this.resetInputButton = this.form.querySelector(
        ".reset-search-input-button",
      );

      this.searchMethods = this.form.querySelector(".search-methods");
      this.searchMethodButtons = this.searchMethods.querySelectorAll("button");
      this.toggleSearchMethodsButton = this.form.querySelector(
        ".toggle-search-methods-button",
      );
      this.toggleSearchMethodsButtonSpan =
        this.toggleSearchMethodsButton.querySelector("span");
      this.select = this.form.querySelector("select");

      this.init();
    }
  }

  /**
   * Add event listeners
   *
   * @returns {void}
   */
  init() {
    // Submit form i.e. reroute
    this.form.addEventListener("submit", (e) => this.boundSubmitForm(e), true);

    // Reset input field
    if (this.resetInputButton && this.input) {
      this.resetInputButton.addEventListener(
        "click",
        () => this.boundResetInput(),
        true,
      );
    }

    // Search input has been focused
    if (this.input) {
      this.input.addEventListener(
        "focus",
        this.boundSetFocusedClassInput,
        true,
      );
    }

    // Open & close the search methods
    if (this.toggleSearchMethodsButton && this.searchMethods) {
      this.toggleSearchMethodsButton.addEventListener(
        "click",
        this.boundToggleSearchMethods,
        true,
      );

      document.addEventListener(
        "click",
        (e) => this.boundCloseSearchMethods(e),
        true,
      );
    }

    // Set select value
    if (this.searchMethodButtons && this.select) {
      this.searchMethodButtons.forEach((button) =>
        button.addEventListener(
          "click",
          (e) => this.boundSetSearchMethod(e),
          true,
        ),
      );
    }
  }

  /**
   *
   * @param {SubmitEvent} e - Event from the submit listener
   *
   * @returns {void}
   */
  submitForm(e) {
    e.preventDefault();

    const selectedSearchMethod = this.select.value;
    const urlParams = new URL(document.location).searchParams;
    const params = Object.fromEntries(urlParams.entries());
    let newUrl = `${location.protocol}//${location.host}/?s=${this.input.value}&zoekmethode=${selectedSearchMethod}`;

    Object.keys(params).forEach((param) => {
      if (param === "s" || param === "zoekmethode") return;

      newUrl += `&${param}=${params[param]}`;
    });

    window.location.href = newUrl;
  }

  /**
   *
   * @returns {void}
   */
  resetInput() {
    console.log("Click");

    this.input.value = "";
  }

  /**
   *
   * @returns {void}
   */
  setFocusedClassInput() {
    this.input.classList.add("focused");
  }

  /**
   *
   * @returns {void}
   */
  toggleSearchMethods() {
    this.toggleSearchMethodsButton.classList.toggle("open");
    this.searchMethods.classList.toggle("show");
  }

  /**
   *
   * @returns {void}
   */
  closeSearchMethods(e) {
    if (
      e.target === this.toggleSearchMethodsButton ||
      e.target.parentNode === this.toggleSearchMethodsButton
    )
      return;

    this.toggleSearchMethodsButton.classList.remove("open");
    this.searchMethods.classList.remove("show");
  }

  /**
   *
   * @param {ClickEvent} e - Event from the click listener
   *
   * @returns {void}
   */
  setSearchMethod(e) {
    this.select.value = e.target.dataset.slug;
    this.toggleSearchMethodsButtonSpan.textContent = e.target.textContent;

    this.searchMethodButtons.forEach((button) => {
      button.classList.remove("selected");
    });

    e.target.classList.add("selected");

    this.toggleSearchMethodsButton.classList.remove("open");
    this.searchMethods.classList.remove("show");
  }
}
